// extracted by mini-css-extract-plugin
export default {"orderItem":"order-item-list__orderItem___DDRIz","button":"order-item-list__button___H371v"};